var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};

site.accessibility = {
	init:function() {
		$(document).keydown(function (e) {
			if (e.which === 9) {
				$('body:not(.admin)').addClass('tabbing');
			}
		});
		$(document).mousedown(function (e) {
			$('body.tabbing').removeClass('tabbing');
		});
	}
};

site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.searchNav = {
	init: function () {

		$('.categoryNav .category > a').on('click', function (e) {
			e.preventDefault();
			e.stopPropagation();

			var $href = $(this)[0].dataset.storemegamenucategory;
			var $root = $('html, body');

			if ($(document).width()+15 >= 992) {
				$('body').addClass('megamenu-open');
				var $level1 = $('#mainmenu').find('li.selectedLevel1');
				var $level1Class = $level1.attr('class').split(' ')[0];
				$('#mainmenu').find('li.' + $level1Class + ' > a').trigger('click');

				var target = $('#mainmenu .si a[data-storeCategory="'+ $href + '"]')
				const $clickEvent = new Event('click');
				target[0].dispatchEvent($clickEvent);

				$root.animate({
					scrollTop: 0
				}, 500);
			}
		});
	}
};

site.filterContent = {
	init: function () {
		const filter = $('.box_filterContent').detach();
		$('main .entryContent').prepend(filter);

		$('main .box table:first-of-type').addClass('filterTable');
		$('main .box table:first-of-type tbody tr:odd').addClass('odd');
		$('main .box table:first-of-type tbody tr:even').addClass('even');
		$('#myInput').on('keyup', function () {
			var value = $(this).val().toLowerCase();
			$('main .box table:first-of-type tbody tr').filter(function () {
				$(this).toggle($(this).text().toLowerCase().indexOf(value) > -1);
			});

			$('main .box table:first-of-type tbody tr').removeClass('odd');
			$('main .box table:first-of-type tbody tr').removeClass('even');

			$('main .box table:first-of-type tbody tr:visible:odd').addClass('odd');
			$('main .box table:first-of-type tbody tr:visible:even').addClass('even');
		});
	},
};

site.svg = {
	init: function () {
		$('img[src*=".svg"]').each(function() {
			var $img = $(this);
			$.get($img.attr('src'), function(data) {
				var $svg = $(data).find('svg').removeAttr('xmlns:a');
				$.each($img.prop('attributes'), function() {
					$svg.attr(this.name, this.value);
				});
				$img.replaceWith($svg);
			}, 'xml');
		});
	}
};

site.frontpage = {
	init: function() {

	}
};

site.maxHeight = {
	init: function () {
		const lang = $('html').attr('lang'),
			description = $('.storeProductView .description'),
			readMoreLabel = lang === 'en' ? 'Read more' : 'Lesa meira',
			readLessLabel = lang === 'en' ? 'Read less' : 'Lesa minna';
		if (!description.length || description[0].scrollHeight < 300) {
			return;
		}
		description.addClass('readMoreContent');
		if (!$('.storeProductView .readMoreToggle').length) {
			description.after(`<button class="readMoreToggle" aria-hidden="true">${readMoreLabel}</button>`);
		}
		let scrollHeight = description[0].scrollHeight;
		if (description.parents('.moya-modal').length) {
			scrollHeight = scrollHeight + 200;
		}

		description.css('max-height', scrollHeight);
		$(window).on('resize', function () {
			description.css('max-height', scrollHeight);
		});
		moya.toggle.addFromSelectors('.readMoreToggle', '.readMoreContent', 'readMore', function () {
			setTimeout(function () {
				$('.readMoreToggle').text(`${readLessLabel}`);
			}, 400);
		}, function () {
			setTimeout(function () {
				$('.readMoreToggle').text(`${readMoreLabel}`);
			}, 400);
		});
	},
};

site.toggle = {
	init: function() {
		site.toggle.mobileSearch();
	},

	mobileSearch: function() {
		moya.toggle.addFromSelectors('.toggle-mobileSearch', '#searchBox', 'mobileSearch', undefined, undefined, {closeOthers: true});
	}
}


// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	site.accessibility.init();
	site.svg.init();
	site.toggle.init();

	site.nav.init();
	site.searchNav.init();


	var $body = $('body');
	if ($body.is('.frontpage')) {
		site.frontpage.init();
	}
	if ($('#storeProductView').length) {
		site.maxHeight.init();
	}

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', 'main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$body.is('.admin')) {
		$('table:not(.custom-responsive)', 'main').wrap('<div class="table-responsive"></div>');
	}

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);

});
